<template>
  <b-col>

    <p v-if="appState.user" class="lead">Вы вошли как пользователь <strong>{{ appState.user.username }}</strong>, роль - {{ appState.user.role == "admin" ? "Администратор" : "Пользователь" }}</p>
    <hr />

    <b-row>

      <b-col
        lg="6"
        v-for="(project, i) in appState.projects"
        :key="project.id"
      >
        <b-card :title="project.name">
          <b-overlay :show="!stats[i]">
            <b-card-text>
              <ShortStats :stats="stats[i]" />
            </b-card-text>
          </b-overlay>

          <div class="justify-content-between d-flex mt-3">
            <b-button variant="secondary" :to="{name: 'project-main', params: {projectId: project.id}}">
              <fa-icon icon="external-link-alt"/> Перейти к проекту
            </b-button>
            <b-button variant="light" title="Редактировать" v-b-tooltip.hover :to="{name: 'project-edit', params: {projectId: project.id}}">
              <fa-icon icon="cog" />
            </b-button>
          </div>
        </b-card>
      </b-col>


    </b-row>


  </b-col>
</template>

<script>
import Api from '@/lib/Api';
import { store } from '@/store';
import ShortStats from '@/components/ShortStats';


export default {
    name: 'Home',
    components: {
        ShortStats
    },
    data () {
        return {
            appState: store.state,
            stats: store.state.projects.map(
                () => { return null; }
            )
        };
    },
    mounted () {
        this.appState.projects.forEach((project, i) => {
            Api.getShortStats(project.id).then(result => {
                this.$set(this.stats, i, result);
            }).catch(error => console.error(error));
        });
    }
};
</script>

<style scoped lang="scss">

 .stats-card .d-flex strong {
     font-size: 1.5rem;
 }
 
</style>
